import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import { useTranslation } from "react-i18next";
import { AiFillCrown } from "react-icons/ai";
import { IoMdCloseCircle } from "react-icons/io";
import { Container, IconButton } from "./styles";

const CommitteCard = ({name, onSetFinalElevation, finalElevation, onDelete, minimumDeadlineDays, t}) => {
  const { i18n } = useTranslation();
  
  return (
    <Container>
      <Tooltip aria-label="Definir como alçada final" title="Definir como alçada final">
        <IconButton>
          <AiFillCrown size={22} color={finalElevation ? '#fff259' : '#ffffffb3'} onClick={onSetFinalElevation} />
        </IconButton>
      </Tooltip>

      <span>
        {name}
        {minimumDeadlineDays && t && (
          <span style={{ fontSize: '12px', color: '#ccc', display: 'block', marginTop: 4 }}>
            {t("softwareManagement.modules.committee.deadlineIndicator", {
              days: minimumDeadlineDays,
            })}
          </span>
        )}
      </span>


      <IoMdCloseCircle color="#fff" onClick={onDelete} size={22} />
    </Container>
  );
};

export default CommitteCard;